module.exports = __webpack_public_path__ + "img/landing_img111.8d0b32a3.png";